import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {provideConfig} from "@spartacus/core";
import {
  GonvarriDownloadOrderPdfComponent
} from "../../components/gonvarri-download-order-pdf/gonvarri-download-order-pdf.component";
import {IconModule} from "@spartacus/storefront";



@NgModule({
  declarations: [
    GonvarriDownloadOrderPdfComponent
  ],
  imports: [
    CommonModule,
    IconModule
  ],
  exports: [
    GonvarriDownloadOrderPdfComponent
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        GonvarriDownloadOrderPdfComponent: {
          component: GonvarriDownloadOrderPdfComponent
        }
      }
    })
  ]
})
export class GonvarriDownloadOrderPdfModule { }
